// extracted by mini-css-extract-plugin
export default {"root":"plain-surface_root__hoZ9R","placeHolderShimmer":"plain-surface_placeHolderShimmer__i6jfd"};